import React, { useEffect, useRef } from "react";
import styled from "styled-components";

function ScrollTop() {
  const scrollRef = useRef(document.createElement("div"));

  useEffect(() => {
    window.onscroll = function () {
      scroll();
    };
  });

  function scroll() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      scrollRef.current.style.display = "block";
    } else {
      scrollRef.current.style.display = "none";
    }
  }

  function top() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <ScrollButton onClick={top} ref={scrollRef}>
      Top
    </ScrollButton>
  );
}

const ScrollButton = styled.div`
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 1rem;
  border: 1px solid #dddfe2;
  outline: none;
  background-color: white;
  color: black;
  cursor: pointer;
  padding: 1rem;
  border-radius: 4px;

  & :hover {
    background-color: #555;
  }
`;

export default ScrollTop;
